import {
  GET_INTERVIEW_LIST_REQUEST,
  GET_INTERVIEW_LIST_SUCCESS,
  GET_INTERVIEW_LIST_FAILURE,
} from "./actionType";

import { getInterviewListService } from "../../config/services/employeeServices";
import ResponseFilter from "../../ResponseFilter";

const getInterviewList = (query) => {
  return (dispatch) => {
    dispatch(getInterviewListRequest());
    getInterviewListService(query)
      .then((res) => {
        let { status, resData } = ResponseFilter(res);
        if (status) {
          dispatch(getInterviewListSuccess(res.data.responseData));
        } else {
          dispatch(getInterviewListFailure(res.data));
        }
      })
      .catch((error) => {
        dispatch(getInterviewListFailure(error));
      });
  };
};

const getInterviewListRequest = () => {
  return {
    type: GET_INTERVIEW_LIST_REQUEST,
  };
};

const getInterviewListSuccess = (data) => {
  return {
    type: GET_INTERVIEW_LIST_SUCCESS,
    payload: data,
  };
};

const getInterviewListFailure = (error) => {
  return {
    type: GET_INTERVIEW_LIST_FAILURE,
    payload: error,
  };
};
export {
  getInterviewList,
  getInterviewListRequest,
  getInterviewListSuccess,
  getInterviewListFailure,
};
